import Credit from "@/components/molecules/credit";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { cn } from "@/lib/utils";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Image from "next/image";
import Link from "next/link";

export type CollectionSliderProps = {
  collections: {
    image: string;
    photographerName?: string;
    photodesc?: string;
    buttonText?: string;
    photoImage?: string;
    link?: string;
    tag?: string;
  }[];
  className?: string;
  locale: Locales;
};

const CollectionSlider = ({ collections, className, locale }: CollectionSliderProps) => {
  return (
    <div className={cn("w-full lg:max-w-[47.188rem] lg:flex-shrink lg:basis-1/2", className)}>
      {collections && collections.length >= 1 && (
        <Carousel className="w-full">
          <CarouselContent className="rounded-lg">
            {collections.map((item, index) => (
              <CarouselItem key={index} aria-label={`Collection image by ${item.photographerName}`}>
                <div className="group/bento relative h-[31.25rem] w-full overflow-hidden rounded-lg md:h-[39.75rem] lg:h-[55.813rem]">
                  <Image
                    src={item.image}
                    alt="Collection"
                    fill
                    className="object-cover transition-all duration-200 ease-in-out group-hover/bento:scale-105"
                    priority
                  />
                  {item.buttonText ||
                    item.photoImage ||
                    item.photodesc ||
                    (item.tag && (
                      <div className="absolute top-3 left-3 z-10 min-[420px]:top-auto min-[420px]:bottom-5 sm:left-3.5">
                        <Credit
                          name={item.photographerName}
                          image={item.photoImage}
                          description={item.photodesc}
                          button={{
                            text: item.buttonText + "",
                          }}
                          locale={locale}
                          state="default"
                          tag={item.tag}
                        />
                      </div>
                    ))}
                  {item.link && (
                    <Link href={item.link} className="absolute inset-0">
                      <span className="sr-only">View Collection</span>
                    </Link>
                  )}
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          {collections.length > 1 && (
            <div className="absolute right-3 bottom-3 flex items-center gap-1 sm:right-5 sm:bottom-5 sm:gap-1.5">
              <CarouselPrevious className="size-8 sm:size-11" aria-label={__("Go to previous Image", locale)}>
                <ArrowLeft aria-hidden="true" />
              </CarouselPrevious>
              <CarouselNext className="size-8 sm:size-11" aria-label={__("Go to next Image", locale)}>
                <ArrowRight aria-hidden="true" />
              </CarouselNext>
            </div>
          )}
        </Carousel>
      )}
    </div>
  );
};

export default CollectionSlider;
